import { render, staticRenderFns } from "./NotificationHistoryTab.vue?vue&type=template&id=07653334&"
import script from "./NotificationHistoryTab.vue?vue&type=script&lang=js&"
export * from "./NotificationHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports